export interface AdminBackgroundSettings {
  _id?: string;
  backgroundImage: string | null;
  backgroundImagePublicId: string | null;
  updatedAt: string;
}

export interface AdminBackgroundState {
  imageUrl: string | null;
  isImageLoaded: boolean;
}
// Redux State Type
export interface AdminBackgroundState {
  imageUrl: string | null;
  isImageLoaded: boolean;
}

// Default background image(used when backend returns null)
export const ADMIN_DEFAULT_BACKGROUND_URL =
  "https://res.cloudinary.com/dv9u0wicr/image/upload/v1761494058/bgimage_original_mpnjqa.png"; //dynamic image

// Secondary overlay image (always static,never changes)
export const ADMIN_OVERLAY_URL =
  "https://res.cloudinary.com/dv9u0wicr/image/upload/v1761494050/square_pic_y5pmjm.png"; //square image

// Fallback color (shown while image is loading)
export const ADMIN_FALLBACK_COLOR = "#1d2835";

// Opacity values
export const ADMIN_BG_OPACITY = 0.1;
export const ADMIN_OVERLAY_OPACITY = 0.5;

// Transition duration
export const ADMIN_TRANSITION_DURATION = 500;
